var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSend = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.617 8.871-.007-.003-16.682-6.92a.92.92 0 0 0-.868.085.96.96 0 0 0-.435.804v4.426a.94.94 0 0 0 .763.92l9.098 1.683a.157.157 0 0 1 0 .307l-9.098 1.682a.94.94 0 0 0-.763.92v4.426a.92.92 0 0 0 .414.77.94.94 0 0 0 .888.08l16.682-6.88.008-.003a1.25 1.25 0 0 0 0-2.297"
  })));
};
export { SvgSend as ReactComponent };